// extracted by mini-css-extract-plugin
module.exports = {"form":"Search_form__2a7Uz","input":"Search_input__2BkS5","input-wrapper":"Search_input-wrapper__22Aov","reset":"Search_reset__3t55I"};